import { Flex } from "antd";
import PropTypes from "prop-types";

import UserOrganizationMainRole from "@/components/UserOrganizationMainRole";
import UserOrganizationName from "@/components/UserOrganizationName";
import UserOrganizationNoRoleAlert from "@/components/UserOrganizationNoRoleAlert";

const UserOrganizationHeader = ({ mainRole, user, loading }) => {
  if (!loading && !mainRole) {
    return <UserOrganizationNoRoleAlert user={user} />;
  }

  return (
    <Flex gap="middle">
      <UserOrganizationMainRole
        mainRole={mainRole}
        user={user}
        loading={loading}
      />
      <UserOrganizationName
        organization={user.organization}
        loading={loading}
      />
    </Flex>
  );
};

UserOrganizationHeader.propTypes = {
  mainRole: PropTypes.object,
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default UserOrganizationHeader;
